<template>
  <div class="list-style clearfix">
    <div
      class="display-inline dispaly-item"
      :class="{'active':itemData.listStyle === 1}"
      @click="changeListStyle"
    >
      <div class="inline-item">
        <span>{{ $t('message["655"]') }}：</span>
        <a-input
          :placeholder="inputPlaceholder"
          disabled
        />
      </div>
      <div class="inline-item">
        <span>{{ $t('message["655"]') }}：</span>
        <a-input
          :placeholder="inputPlaceholder"
          disabled
        />
      </div>
    </div>
    <div
      class="display-block dispaly-item"
      :class="{'active':itemData.listStyle === 2}"
      @click="changeListStyle2"
    >
      <div class="inline-item">
        <span>{{ $t('message["655"]') }}：</span>
        <a-input
          :placeholder="inputPlaceholder"
          disabled
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    inputPlaceholder () {
      return this.$t('message["1264"]')
    }
  },
  methods: {
    changeListStyle () {
      this.itemData.listStyle = 1
    },
    changeListStyle2 () {
      this.itemData.listStyle = 2
    }
  }
}
</script>
<style lang="scss" scoped>
.list-style::v-deep {
  .dispaly-item {
    float: left;
    padding: 12px 12px 0;
    width: 248px;
    border: 1px solid #ebebeb;
    border-radius: 4px;
    min-height: 102px;
    cursor: pointer;
    .ant-input{
      width: 164px;
      background:#fff;
    }
    .inline-item {
      margin-bottom: 12px;
    }
  }
  .dispaly-item:hover {
    border-color: #5077aa;
  }
  .display-block {
    float: right;
    span{
      display: block;
      padding-bottom: 10px;
    }
  }
  .active {
    border-color: #5077aa;
    // box-shadow: 0 0 0 2px rgba(80, 119, 170, 0.2);
  }
}
</style>
